import { IOnboardDingPlaylistResponseField } from "~/lib/types/onboarding.videos.type";
import { LOCALE_MAPPING_MOBILE } from "../const";

export const getTranslationVideoName = (
  playlist: IOnboardDingPlaylistResponseField,
  locale?: string
) => {
  if (!playlist) {
    return;
  }

  if (!locale) {
    return playlist.name;
  }

  const mappingLocale = LOCALE_MAPPING_MOBILE[locale] || locale;

  return playlist.localisation?.name[mappingLocale] || playlist.name;
};
